export default __webpack_public_path__ + "static/media/Cartolina.7b9e9de4.jpg";